import { Directive } from '@angular/core';

@Directive({
  selector: '[appCommon]'
})
export class CommonDirective {

  constructor() { }

}
